"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const index_1 = require("../../index");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const OsmosysBaseEntity_1 = require("../OsmosysBaseEntity");
const ContentConversion_1 = require("../converter/ContentConversion");
const ContentFeed_1 = require("./ContentFeed");
const ContentSystem_1 = require("./ContentSystem");
const auth_1 = require("../auth");
let ContentMapping = class ContentMapping extends OsmosysBaseEntity_1.OsmosysBaseEntity {
};
tslib_1.__decorate([
    type_graphql_1.Field(() => auth_1.User),
    typeorm_1.ManyToOne(() => auth_1.User, {
        cascade: true,
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], ContentMapping.prototype, "creatingUser", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column(),
    tslib_1.__metadata("design:type", String)
], ContentMapping.prototype, "name", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => ContentSystem_1.ContentSystem, { nullable: true }),
    typeorm_1.ManyToOne(() => ContentSystem_1.ContentSystem, contentSystem => contentSystem.contentMappings),
    tslib_1.__metadata("design:type", Object)
], ContentMapping.prototype, "contentSystem", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.RelationId((obj) => obj.contentSystem),
    tslib_1.__metadata("design:type", Number)
], ContentMapping.prototype, "contentSystemId", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => ContentFeed_1.ContentFeed, { nullable: true }),
    typeorm_1.ManyToOne(() => ContentFeed_1.ContentFeed, contentFeed => contentFeed.sampledForContentMappings, {
        lazy: true,
        nullable: true,
    }),
    tslib_1.__metadata("design:type", Object)
], ContentMapping.prototype, "sampleContentFeed", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [ContentFeed_1.ContentFeed]),
    typeorm_1.OneToMany(() => ContentFeed_1.ContentFeed, contentFeed => contentFeed.contentMapping, {
        lazy: true,
    }),
    tslib_1.__metadata("design:type", Object)
], ContentMapping.prototype, "contentFeeds", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], ContentMapping.prototype, "pathToArray", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], ContentMapping.prototype, "pathToTitle", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], ContentMapping.prototype, "pathToDate", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({
        default: true,
        type: 'boolean',
    }),
    tslib_1.__metadata("design:type", Boolean)
], ContentMapping.prototype, "isArray", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => index_1.GraphQLJSON, { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'jsonb',
    }),
    tslib_1.__metadata("design:type", Array)
], ContentMapping.prototype, "fields", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [ContentConversion_1.ContentConversion]),
    typeorm_1.ManyToMany(() => ContentConversion_1.ContentConversion, conversion => conversion.contentMappings, {
        lazy: true,
    }),
    typeorm_1.JoinTable(),
    tslib_1.__metadata("design:type", Object)
], ContentMapping.prototype, "conversions", void 0);
ContentMapping = tslib_1.__decorate([
    type_graphql_1.ObjectType(),
    typeorm_1.Entity()
], ContentMapping);
exports.ContentMapping = ContentMapping;
class ContentMappingEntity extends ContentMapping {
    toEndpoint() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const cs = this.contentSystem;
            if (!cs) {
                return `/integrations?failed=${encodeURI('No content system found')}`;
            }
            return `/integrations/${cs.id}/mappings/${this.id}`;
        });
    }
    toString() {
        return this.name;
    }
}
exports.ContentMappingEntity = ContentMappingEntity;
//# sourceMappingURL=ContentMapping.js.map